export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;

/** Slow enough to read as attention, not as a spinner. Shared so every ambient alarm pulses in step. */
export const AMBIENT_PULSE_MS = 2400;
